import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthStore } from '@/modules/administracion/auth';
import { PrivateRoute } from './PrivateRoute';
import { DashboardLayout } from '@/app/layouts/DashboardLayout';
import { AuthLayout } from '@/app/layouts/AuthLayout';
import { LoginPage } from '@/modules/administracion/auth/pages/LoginPage';
import { RecuperarContrasena } from '@/modules/administracion/auth/pages/RecuperarContrasena';
import RestablecerContrasena from '@/modules/administracion/auth/pages/RestablecerContrasena';
import ActivarCuentaPage from '@/modules/administracion/auth/pages/ActivarCuenta';

// NOTA: Módulos Routes ya NO se importan aquí
// TabContainer maneja el renderizado usando tabRouteRegistry

// Componente para manejar la ruta raíz
const RootRedirect = () => {
  const { isAuthenticated } = useAuthStore();
  const [isHydrated, setIsHydrated] = useState(false);

  // Esperar a que el estado persistido se haya cargado
  useEffect(() => {
    // Pequeño delay para asegurar que el estado persistido se haya hidratado
    const timer = setTimeout(() => {
      setIsHydrated(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Mostrar nada mientras se carga el estado
  if (!isHydrated) {
    return null;
  }

  // Si está autenticado, redirigir a dashboard
  // Si no, redirigir a login
  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
};

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Ruta raíz - redirige según estado de autenticación */}
      <Route path="/" element={<RootRedirect />} />

      {/* Rutas de autenticación */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
        <Route path="/restablecer-contrasena" element={<RestablecerContrasena />} />
        <Route path="/restablecer-contrasena/:token" element={<RestablecerContrasena />} />
        <Route path="/activar-cuenta" element={<ActivarCuentaPage />} />
      </Route>

      {/* Rutas protegidas */}
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        {/* 
          ═══════════════════════════════════════════════════════════
          ARQUITECTURA DE TABS - TabContainer maneja el renderizado
          ═══════════════════════════════════════════════════════════
          
          PROBLEMA ANTERIOR (Doble Renderizado):
          ❌ AppRoutes definía rutas → React Router <Outlet /> las renderizaba
          ❌ TabContainer TAMBIÉN renderizaba los componentes
          ❌ Resultado: 2 instancias del componente = 2 llamadas al backend
          
          SOLUCIÓN ACTUAL:
          ✅ TabContainer es el ÚNICO responsable de renderizar componentes
          ✅ Usa tabRouteRegistry (app/routes/tabRouteRegistry.tsx) para mapear rutas → componentes
          ✅ AppRoutes solo define catch-all que delega a TabContainer
          
          PARA AÑADIR NUEVA RUTA AL SISTEMA DE TABS:
          1. Ir a: app/routes/tabRouteRegistry.tsx
          2. Importar el componente de página del módulo
          3. Añadir entrada al TAB_ROUTE_REGISTRY
          
          Ejemplo:
          ```typescript
          // app/routes/tabRouteRegistry.tsx
          import { MiNuevaPagina } from '@/modules/mi-modulo';
          
          export const TAB_ROUTE_REGISTRY = {
            // ...
            '/mi-modulo/mi-ruta': MiNuevaPagina,
          };
          ```
        */}

        {/* Catch-all - TabContainer maneja TODO el routing dentro del dashboard */}
        <Route path="*" element={null} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<div>404 - Página no encontrada</div>} />
    </Routes>
  );
};
